// 教育经历认证
<template>
  <div>
    <div class="contentList">
      <el-empty :image="emptyImg" v-if="currStudentInfo.length <= 0"></el-empty>
      <el-timeline style="margin-left: 0.2rem">
        <el-timeline-item
          v-for="(val, idx) in currStudentInfo"
          :key="idx"
          color="#198cff"
          size="large"
        >
          <div style="margin-left:4%">
            <h1 class="eduTitle">教育信息{{ idx + 1 }}</h1>
            <div class="eduInfo">
              <el-row :gutter="50">
                <el-col :span="9">
                  <el-form ref="form" :disabled="true" label-width="0.8rem">
                    <el-form-item label="学历:">
                      <el-input v-model="val.educationStr || '-'"></el-input>
                    </el-form-item>
                    <el-form-item label="学校:">
                      <el-input v-model="val.schoolName || '-'"></el-input>
                    </el-form-item>
                    <el-form-item label="学院:">
                      <el-input v-model="val.college || '-'"></el-input>
                    </el-form-item>
                    <el-form-item label="专业:">
                      <el-input v-model="val.major || '-'"></el-input>
                    </el-form-item>
                    <el-form-item label="在校时间:">
                      <span class="text_26"
                        >{{ val.startYear  }}-{{ val.endYear  }}</span
                      >
                    </el-form-item>
                    <el-form-item v-if="val.updateUser" label="审核人:">
                      <p>{{ val.updateUser || '-' }}</p>
                    </el-form-item>
                    <el-form-item label="审核状态:">
                      <p style="color: #198cff" v-if="val.state == 0">
                        待审核
                      </p>
                      <p style="color: #2ee12e" v-if="val.state == 1">
                        已认证
                      </p>
                      <p style="color: #ea2727" v-if="val.state == 2">
                        未通过
                      </p>
                      <p style="color: #f28e0c" v-if="val.state == 3">
                        待二次审核
                      </p>
                    </el-form-item>
                    <el-form-item label="审核时间:" v-if="val.state != 0">
                      <el-input v-model="val.updateTime || '-'"></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :span="15">
                  <el-form ref="form" :disabled="true" label-width="80px">
                    <el-form-item label="教育认证:">
                      <el-row :gutter="50">
                        <el-col :span="9">
                          <el-image
                            class="car"
                            :src="apiUrl + (val.imgUrl || '')"
                            :preview-src-list="[apiUrl + (val.imgUrl || '')]"
                          >
                           <div slot="error" class="el-image__error">
                         {{ !val.imgUrl?'暂无图片':'加载失败' }} 
                        </div>
                          </el-image>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              <img
                v-if="val.state == 1"
                class="judImg"
                src="../../assets/images/isAudit.png"
                alt=""
              />
              <img
                v-if="val.state == 2"
                class="judImg"
                src="../../assets/images/noAudit.png"
                alt=""
              />
              <img
                v-if="val.state == 0"
                class="judImg"
                src="../../assets/images/audit.png"
                alt=""
              />
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
export default {
  props: ["currStudentInfo"],
  data() {
    return {
      emptyImg: require("../../assets/images/emptyImg.png"),
      apiUrl: "",
      list_ZloHYvTf: [0, 0, 0],
      currentPage: 1
    };
  },
  created() {
    this.apiUrl = window.api.apiurl;
  },
  mounted() {},
  methods: {
    //查看大图
    seeDetials(url) {
      window.open(`${this.apiUrl}${url}`);
    }
  }
};
</script>
<style lang="scss" scoped>
>>> .el-timeline-item__tail {
  height: 104% !important;
}
>>> .el-input__inner {
  color: #303133 !important;
  border: none !important;
  background: none !important;
  cursor: default !important;
}

.eduInfo {
  position: relative;
  padding: 20px 5%;
  width: 95%;
  box-shadow: 0px 2px 6px 0px rgba(22, 99, 169, 0.26);
  border-radius: 5px;
}
.eduTitle {
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  margin: 0.25rem 0 0.3rem;
}

.contentList {
  img.car {
    border: 1px solid #dedede;
    width: 100%;
    background: #eeeeee;
    box-sizing: border-box;
    border-radius: 0.05rem;
  }
  >>> .car {
    border: 1px solid #dedede;
    width: 100%;
    height: 1.4rem;
    background: #eeeeee;
    box-sizing: border-box;
    border-radius: 0.05rem;
    .text_26 {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userDetail/education.vue